
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <error [error]="error"></error>
  <div class="row">
    <div class="col">
      <h3 class="alert alert-info">PoC Daas Project</h3>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="card-item">
        <div class="row">
          <div class="col-12">
            <h5>Devices on this project</h5>
          </div>
        </div>
        <div class="row" *ngIf="targetSystem !== 'legacy'">
          <div class="col-12">
            <div class="row">
              <div class="form-group col-lg-6">
                <div>Customer Name</div>
                <div class="border-bottom text-secondary">{{project?.customerName}}&nbsp;</div>
              </div>
              <div class="form-group col-lg-6">
                <div>Customer BP ID</div>
                <div class="border-bottom text-secondary">{{project?.customerBpId}}&nbsp;</div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-6">
                <div>Reseller Name</div>
                <div class="border-bottom text-secondary">{{project?.resellerName}}&nbsp;</div>
              </div>
              <div class="form-group col-lg-6">
                <div>Reseller BP ID</div>
                <div class="border-bottom text-secondary">{{project?.resellerBpId}}&nbsp;</div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-6">
                <div>Unique ID</div>
                <div class="border-bottom text-secondary">{{project?.uniqueId}}&nbsp;</div>
              </div>
              <div class="form-group col-lg-6">
                <div>Opportunity ID</div>
                <div class="border-bottom text-secondary">{{project?.opportunityId}}&nbsp;</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <property-container>
              <property-item>Total Devices: {{ project?.totalDevices | number:0 }}</property-item>
              <property-item>Available Devices: {{ project?.totalDevices - project?.plannedDevices | number:0 }}</property-item>
              <property-item>Planned Devices: {{ project?.plannedDevices | number:0  }}</property-item>
              <property-item>Ordered Devices: {{ project?.orderedDevices | number:0  }}</property-item>
              <property-item>Deployed Devices: {{ project?.deployedDevices | number:0  }}</property-item>
            </property-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>